<template>
<v-container>
    <div class="d-flex justify-end">
        <v-btn color="primary" to="/admin/kegiatan/submitKhotib">Tambah Khatib</v-btn>
    </div>
    <div class="mt-4">
        <v-data-table class="elevation-1" :headers="headers" :items="items">
        <template v-slot:top>
            <v-text-field label="Search" class="mx-4"> </v-text-field>
        </template>
        <template v-slot:item.actions>
          <v-btn icon>
            <v-icon small> mdi-pencil </v-icon>
          </v-btn>
          <v-btn icon>
            <v-icon small> mdi-delete </v-icon>
          </v-btn>
        </template>
        </v-data-table>
    </div>
</v-container>
</template>

<script>
export default {
  data() {
    return {
      headers: [
        { text: "No", value: "no" },
        { text: "Tanggal", value: "date" },
        { text: "Khatib", value: "khatib" },
        { text: "Muadzin", value: "muadzin" },
        { text: "Materi Khutbah", value: "materi_khutbah" },
        { text: "Aksi", value: "actions"}
      ],
      items: [],
    };
  },
  created() {
    this.axios("/masjid/soljum/list")
    .then((response) => {
      console.log(response.data.data)
      this.items = response.data.data
      for(let i = 0; i < this.items.length; i++){
        this.items[i].no = i + 1;
      }
    })
    .catch((error) => {
      console.log(error, 'error fetch list soljum')
    })
  }
};
</script>

<style>
</style>